let upperConstLabels = [
	{
		label: 'C3A2',
		gravity: 'center',
		channelId: 1,
		value: 0,
		xOffset: 0,
		yOffset: -7,
		color: 'black',
		font: '15px Arial'
	}, {
		label: 'C4A1',
		gravity: 'center',
		channelId: 2,
		value: 0,
		xOffset: 0,
		yOffset: -7,
		color: 'black',
		font: '15px Arial'
	}, {
		label: 'F3A2',
		gravity: 'center',
		channelId: 3,
		value: 0,
		xOffset: 0,
		yOffset: -7,
		color: 'black',
		font: '15px Arial'
	}, {
		label: 'F4A1',
		gravity: 'center',
		channelId: 4,
		value: 0,
		xOffset: 0,
		yOffset: -7,
		color: 'black',
		font: '15px Arial'
	}, {
		label: 'O1A2',
		gravity: 'center',
		channelId: 5,
		value: 0,
		xOffset: 0,
		yOffset: -7,
		color: 'black',
		font: '15px Arial'
	}, {
		label: 'O2A1',
		gravity: 'center',
		channelId: 6,
		value: 0,
		xOffset: 0,
		yOffset: -7,
		color: 'black',
		font: '15px Arial'
	}, {
		label: 'EOG1',
		gravity: 'center',
		channelId: 7,
		value: 0,
		xOffset: 0,
		yOffset: -7,
		color: 'black',
		font: '15px Arial'
	}, {
		label: 'EOG2',
		gravity: 'center',
		channelId: 8,
		value: 0,
		xOffset: 0,
		yOffset: -7,
		color: 'black',
		font: '15px Arial'
	}, {
		label: 'EMG',
		gravity: 'center',
		channelId: 9,
		value: 0,
		xOffset: 0,
		yOffset: -7,
		color: 'black',
		font: '15px Arial'
	}, {
		label: 'ECG',
		gravity: 'center',
		channelId: 10,
		value: 0,
		xOffset: 0,
		yOffset: -7,
		color: 'black',
		font: '15px Arial'
	}
]

let lowerConstLabels = [
	{
		label: 'Sound',
		gravity: 'center',
		channelId: 11,
		value: 0,
		xOffset: 0,
		yOffset: -7,
		color: 'black',
		font: '15px Arial'
	}, {
		label: 'NPress',
		gravity: 'center',
		channelId: 12,
		value: 0,
		xOffset: 0,
		yOffset: -7,
		color: 'black',
		font: '15px Arial'
	}, {
		label: 'Therm',
		gravity: 'center',
		channelId: 13,
		value: 0,
		xOffset: 0,
		yOffset: -7,
		color: 'black',
		font: '15px Arial'
	}, {
		label: 'Thor',
		gravity: 'center',
		channelId: 14,
		value: 0,
		xOffset: 0,
		yOffset: -7,
		color: 'black',
		font: '15px Arial'
	}, {
		label: 'Abdo',
		gravity: 'center',
		channelId: 15,
		value: 0,
		xOffset: 0,
		yOffset: -7,
		color: 'black',
		font: '15px Arial'
	}, {
		label: 'SpO2',
		gravity: 'center',
		channelId: 16,
		value: 75,
		xOffset: 0,
		yOffset: -7,
		color: 'black',
		font: '15px Arial'
	}, {
		label: '%',
		gravity: 'center',
		channelId: 16,
		value: 75,
		xOffset: 0,
		yOffset: 7,
		color: 'black',
		font: '12px Arial'
	}, {
		label: '100',
		gravity: 'right',
		channelId: 16,
		value: 100,
		xOffset: -3,
		yOffset: 0,
		color: 'black',
		font: '8px Arial'
	}, {
		label: 'LimbL',
		gravity: 'center',
		channelId: 17,
		value: 0,
		xOffset: 0,
		yOffset: -7,
		color: 'black',
		font: '15px Arial'
	}, {
		label: 'LimbR',
		gravity: 'center',
		channelId: 18,
		value: 0,
		xOffset: 0,
		yOffset: -7,
		color: 'black',
		font: '15px Arial'
	}, {
		label: 'Pulse',
		gravity: 'center',
		channelId: 19,
		value: 150,
		xOffset: 0,
		yOffset: -7,
		color: 'black',
		font: '15px Arial'
	}, {
		label: 'bpm',
		gravity: 'center',
		channelId: 19,
		value: 150,
		xOffset: 0,
		yOffset: 7,
		color: 'black',
		font: '12px Arial'
	}, {
		label: '300',
		gravity: 'right',
		channelId: 19,
		value: 300,
		xOffset: -3,
		yOffset: 0,
		color: 'black',
		font: '8px Arial'
	}, {
		label: '0',
		gravity: 'right',
		channelId: 19,
		value: 0,
		xOffset: -3,
		yOffset: 0,
		color: 'black',
		font: '8px Arial'
	}, {
		label: 'Position',
		gravity: 'left',
		channelId: 20,
		value: 0,
		xOffset: 3,
		yOffset: -7,
		color: 'black',
		font: '15px Arial'
	}, {
		label: 'Right',
		gravity: 'right',
		channelId: 20,
		value: 2,
		xOffset: -3,
		yOffset: 0,
		color: 'black',
		font: '8px Arial'
	}, {
		label: 'Supine',
		gravity: 'right',
		channelId: 20,
		value: 1,
		xOffset: -3,
		yOffset: 0,
		color: 'black',
		font: '8px Arial'
	}, {
		label: 'Left',
		gravity: 'right',
		channelId: 20,
		value: 0,
		xOffset: -3,
		yOffset: 0,
		color: 'black',
		font: '8px Arial'
	}, {
		label: 'Prone',
		gravity: 'right',
		channelId: 20,
		value: -1,
		xOffset: -3,
		yOffset: 0,
		color: 'black',
		font: '8px Arial'
	}, {
		label: 'Upright',
		gravity: 'right',
		channelId: 20,
		value: -2,
		xOffset: -3,
		yOffset: 0,
		color: 'black',
		font: '8px Arial'
	}
]

export {
	upperConstLabels,
	lowerConstLabels
}